var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.8898C14.5681 2.50343 15.4166 3.77762 15.4166 5.25C15.4166 6.72238 14.5681 7.99657 13.3333 8.6102M15 12.972C16.2595 13.5419 17.3937 14.4708 18.3333 15.6667M1.66663 15.6667C3.2887 13.6021 5.49094 12.3333 7.91663 12.3333C10.3423 12.3333 12.5446 13.6021 14.1666 15.6667M11.6666 5.25C11.6666 7.32107 9.98769 9 7.91663 9C5.84556 9 4.16663 7.32107 4.16663 5.25C4.16663 3.17893 5.84556 1.5 7.91663 1.5C9.98769 1.5 11.6666 3.17893 11.6666 5.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/employment.dee8635969b0af81e84c30591a4f866b.svg";
export { ForwardRef as ReactComponent };